"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Grid_1 = __importDefault(require("@material-ui/core/Grid/Grid"));
const Icon_1 = __importDefault(require("@material-ui/core/Icon"));
const styles_1 = require("@material-ui/core/styles");
const totango_utils_1 = require("@totango-app-team/totango-utils");
const classnames_1 = __importDefault(require("classnames"));
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const resources_1 = require("../../../utils/resources");
const add_item_button_1 = __importDefault(require("../../add-item-button/add-item-button"));
const advanced_select_1 = __importDefault(require("../../advanced-select/advanced-select"));
const character_count_text_input_1 = __importDefault(require("../../character-count-text-input/character-count-text-input"));
const checkbox_1 = __importDefault(require("../../checkbox/material/checkbox"));
const collapse_expand_button_1 = __importDefault(require("../../collapse-expand-button/collapse-expand-button"));
const successbloc_icon_1 = __importDefault(require("../../icons/successbloc-icon"));
const input_1 = __importDefault(require("../../input/input"));
const notify_1 = require("../../notify/notify");
const switch_group_1 = __importDefault(require("../../switch-group/switch-group"));
const tooltip_1 = __importDefault(require("../../tooltip/tooltip"));
const tree_view_1 = __importDefault(require("../../tree-view/tree-view"));
const typography_1 = __importDefault(require("../../typography/typography"));
const modal_1 = __importDefault(require("../modal/modal"));
const utils_1 = require("./utils");
require("../../../styles/components/copy-move-resource-modal.less");
const StyledTooltip = (0, styles_1.withStyles)({
    tooltip: {
        fontSize: 12,
    },
})(tooltip_1.default);
const { safeParsing } = totango_utils_1.utils;
const EMPTY_ARRAY = [];
const UNMAPPED_TRACK_OPTION = {
    id: -1,
    value: -1,
    label: 'Unmapped Cards',
    relations: [],
};
const newTrackPositionOptions = [
    {
        key: 'top',
        value: 'Top',
    },
    {
        key: 'bottom',
        value: 'Bottom',
    },
];
const ALLOWED_RESOURCE_TYPES = [resources_1.BULK, resources_1.SUCCESS_PLAY, resources_1.CAMPAIGN, resources_1.EXPERIENCE];
const mapFoldersArrayWithTabOfGlobal = (f) => (!f.tab ? ({ ...f, tab: null }) : f);
const CopyMoveResourceModal = ({ item, bulkItems, isOpen, closeModal, currentFolderLocationId, currentSbLocationId, title, onSubmitCallback, onBulkSubmitCallback, action, resourceType, availableForZoe, setAvailableForZoe, prevItem, validateModalForm, maximumNameLength, showDescription, usedNames, shouldDisableFolderButtonForGlobal, isExpanded, isEditable, hideGlobal, successBlocs, labelResources, folderData: folderDataProps, allFolderData: allFolderDataProps, authUser, isLoadingUsedNames, userTeamsMap, allTeams, activityTypes, getRestrictedNames, tracks, isLoadingTracks, hasBlockPermissions, createFolders, createFolderInGlobal, isUserAdmin, updateFoldersEmber, setSbId, hidePrivacySwitch = false, hidePersonalFolder = false, }) => {
    // when tab is global so set it as null so the function 'utils.getSelectedFolderTree' will know to check if this global.
    const folderData = (0, react_1.useMemo)(() => folderDataProps.map(mapFoldersArrayWithTabOfGlobal), [folderDataProps]);
    const allFolderData = (0, react_1.useMemo)(() => allFolderDataProps.map(mapFoldersArrayWithTabOfGlobal), [allFolderDataProps]);
    const bulkMode = !!bulkItems.length;
    const labels = (0, react_1.useMemo)(() => item?.entity_id
        && labelResources.filter((resource) => resource.resource_id === item.entity_id).map((label) => label.label_id), [labelResources, item]);
    const userTeams = (0, react_1.useMemo)(() => (authUser.isSwitchedAccounts ? allTeams : userTeamsMap[authUser.username]) || EMPTY_ARRAY, [authUser.isSwitchedAccounts, authUser.username, allTeams, userTeamsMap]);
    const userEmail = authUser.email || authUser.username;
    const isZoeUser = authUser?.isZoeUser;
    const initialName = (0, react_1.useMemo)(() => {
        if (bulkMode) {
            return '';
        }
        if (resourceType === resources_1.SEGMENT && action === 'Save') {
            return item.name || 'Untitled Segment';
        }
        if (action === 'Move') {
            return item.name;
        }
        if (resourceType === resources_1.EXPERIENCE) {
            return `${item.name} copy`;
        }
        // generate new name that is unique based on the `usedNames` set
        if (usedNames instanceof Set) {
            const appendix = '_copy';
            let newName = `${item.name}`;
            do {
                newName += appendix;
            } while (usedNames.has(newName));
            return newName;
        }
        return `${item.name}_copy`;
    }, [bulkMode, action, item, resourceType, usedNames]);
    const [name, setName] = (0, react_1.useState)(initialName);
    (0, react_1.useEffect)(() => {
        setName(initialName);
    }, [bulkMode, initialName]);
    const [description, setDescription] = (0, react_1.useState)(item?.description || '');
    const [validateForm, setValidateForm] = (0, react_1.useState)({});
    const onNameChange = (0, react_1.useCallback)(({ target: { value } }) => {
        if (usedNames instanceof Set) {
            if (usedNames.has(value)) {
                setValidateForm({
                    name: true,
                    error: 'Name is already in use',
                });
            }
            else {
                setValidateForm(false);
            }
        }
        if (value !== name) {
            setName(value);
        }
    }, [name, usedNames]);
    (0, react_1.useEffect)(() => {
        // when usedNames changed
        // we need re-run name validation to make sure it's not busy in new selected SB
        onNameChange({ target: { value: name } });
    }, [name, onNameChange]);
    const onDescChange = (0, react_1.useCallback)(({ target: { value } }) => setDescription(value), []);
    const hasTools = !hideGlobal
        && (0, utils_1.checkUserPermission)('update', 'app-tools', authUser.rolePermissions)
        && (0, utils_1.checkUserPermission)('read', 'app-tools', authUser.rolePermissions);
    const hasConflictTerms = (0, react_1.useMemo)(() => (resourceType === 'report'
        && item?.configuration?.ui_configurations?.customFilters
        && (0, utils_1.hasContextConflictTerms)(item?.configuration?.ui_configurations?.customFilters))
        || (resourceType === 'segment'
            && ((item.terms && (0, utils_1.hasContextConflictTerms)(item.terms))
                || (item.criteria?.terms && (0, utils_1.hasContextConflictTerms)(item.criteria.terms)))), [item, resourceType]);
    const sb = successBlocs.find((successBloc) => successBloc.id.toString() === (bulkMode ? currentSbLocationId : item?.sb_id && item.sb_id.toString()));
    const [loading, setLoading] = (0, react_1.useState)(false);
    const locationOptions = (0, react_1.useMemo)(() => {
        const options = [];
        if (isZoeUser && resourceType === 'segment' && !hidePersonalFolder) {
            return [
                {
                    icon: 'folder_shared',
                    value: 'My Personal Folder',
                    key: utils_1.PERSONAL_FOLDER_ID,
                },
            ];
        }
        if (!hasConflictTerms || (hasConflictTerms && !sb)) {
            // Only the segment owner can change the visibility of segment list
            if (resourceType === 'segment' && !(action === 'Move' && item.owner !== userEmail) && !hidePersonalFolder) {
                options.push({
                    icon: 'folder_shared',
                    value: 'My Personal Folder',
                    key: utils_1.PERSONAL_FOLDER_ID,
                });
            }
            if (hasTools) {
                options.push({
                    icon: 'build',
                    value: 'Global',
                    key: 1,
                    // In Global SB the sorting is not case-sensitive, to do the same toLowerCase() was used.
                    items: resourceType === 'segment'
                        ? (0, utils_1.buildFolderTree)((0, sortBy_1.default)(folderData.filter((data) => data.type === 'folder'), (folder) => folder.name.toLowerCase()))
                        : [],
                });
            }
        }
        if (!hasConflictTerms) {
            options.push({
                iconComponent: react_1.default.createElement(successbloc_icon_1.default, null),
                value: 'SuccessBLOCS',
                key: 'sb',
                items: successBlocs
                    .filter((successBloc) => {
                    if (successBloc.id === 0) {
                        return false;
                    }
                    if (bulkMode || !successBloc.tabs_config) {
                        return true;
                    }
                    const tabsConfig = safeParsing(successBloc.tabs_config, {}, null);
                    const resourceTypeForTabConfig = resourceType === 'experience' ? 'inApp' : `${resourceType}s`;
                    return tabsConfig[resourceTypeForTabConfig];
                })
                    .map((s) => ({
                    key: `sb_${s.id}`,
                    value: s.display_name,
                    iconClass: activityTypes.find((a) => a.activity_type_id === s.activity_type_id)?.icon_class,
                    items: isEditable
                        ? (0, utils_1.buildSbFoldersTree)((0, utils_1.getFoldersBySbId)(allFolderData, s.id, `sb-${resourceType}s`), utils_1.ROOT_ID)
                        : [],
                    sbId: s.id,
                })),
            });
        }
        return options;
    }, [
        isZoeUser,
        resourceType,
        hasConflictTerms,
        sb,
        action,
        item,
        userEmail,
        hasTools,
        folderData,
        successBlocs,
        bulkMode,
        activityTypes,
        isEditable,
        allFolderData,
        hidePersonalFolder,
    ]);
    const getFolderId = (0, react_1.useCallback)((selectedFolderId, location, locationChanged) => selectedFolderId
        || (location && locationChanged && location.id)
        || (!locationChanged && item?.id && (0, utils_1.findFolderByResourceId)(item.id, resourceType, allFolderData)), [item, allFolderData, resourceType]);
    const initialLocation = (0, react_1.useMemo)(() => (0, utils_1.getInitialLocationValue)(hasConflictTerms, sb, locationOptions, item, allFolderData, currentFolderLocationId, currentSbLocationId, resourceType), [
        hasConflictTerms,
        sb,
        locationOptions,
        item,
        currentFolderLocationId,
        currentSbLocationId,
        resourceType,
        allFolderData,
    ]);
    const [location, setLocation] = (0, react_1.useState)(initialLocation);
    (0, react_1.useEffect)(() => {
        setLocation(initialLocation);
    }, [initialLocation]);
    const [locationChanged, setLocationChanged] = (0, react_1.useState)(false);
    const [navList, setNavList] = (0, react_1.useState)({ sb: '', folders: [] });
    const sbLocationId = (hasConflictTerms && sb && sb.id.toString())
        || (location
            && typeof location.key === 'string'
            && location.key.indexOf('sb_') > -1
            && location.key.replace('sb_', ''));
    const chosenSb = sbLocationId && successBlocs.find((s) => s.id.toString() === sbLocationId.toString());
    const selectedFolderId = location
        && typeof location.key === 'string'
        && location.key.indexOf('folder_') > -1
        && parseInt(location.key.replace('folder_', ''), 10);
    const folderId = getFolderId(selectedFolderId, location, locationChanged);
    const folder = folderId && (0, utils_1.getFolderById)(allFolderData, folderId);
    const sbId = (0, react_1.useMemo)(() => (folder ? folder.sb_id : chosenSb.id || (!locationChanged && item?.sb_id) || 0), [chosenSb.id, folder, item?.sb_id, locationChanged]);
    const activityType = sb && activityTypes.find((activity) => activity.activity_type_id === sb.activity_type_id);
    const [newPositionInTrack, setNewPositionInTrack] = (0, react_1.useState)(newTrackPositionOptions[0]);
    const onTrackPositionChange = (0, react_1.useCallback)((e, value) => setNewPositionInTrack(value), []);
    const [selectedTrack, setSelectedTrack] = (0, react_1.useState)(null);
    const trackOptions = (0, react_1.useMemo)(() => {
        setSelectedTrack(UNMAPPED_TRACK_OPTION);
        const result = [UNMAPPED_TRACK_OPTION];
        const modifiedTracks = tracks.map(({ id, name: trackName, relations }) => ({ value: id, label: trackName, relations, id })) || [];
        return (result).concat(modifiedTracks);
    }, [tracks]);
    (0, react_1.useEffect)(() => {
        if (setSbId) {
            setSbId(sbId);
        }
    }, [sbId, setSbId]);
    (0, react_1.useEffect)(() => {
        if (!selectedTrack) {
            const { track_id: trackId } = item;
            if (trackId !== -1) {
                const selTrack = trackOptions.find(({ id }) => id === trackId);
                if (selTrack) {
                    setSelectedTrack(selTrack);
                }
                else {
                    setSelectedTrack(UNMAPPED_TRACK_OPTION);
                }
            }
            else {
                setSelectedTrack(UNMAPPED_TRACK_OPTION);
            }
        }
    }, [item, selectedTrack, trackOptions]);
    const handleTrackSelect = (0, react_1.useCallback)((value) => {
        setSelectedTrack(value);
    }, []);
    const setCurrentLocation = (0, react_1.useCallback)((currentLocation) => {
        setValidateForm({});
        setLocation(currentLocation);
        setLocationChanged(true);
        const isSbSelected = currentLocation.key && `${currentLocation.key}`.indexOf('sb_') === 0;
        const didChangeSB = currentLocation.key !== `sb_${sbLocationId}`;
        const isSelectedGlobal = currentLocation?.value === 'Global';
        if ((isSbSelected || isSelectedGlobal) && didChangeSB && ALLOWED_RESOURCE_TYPES.includes(resourceType)) {
            setSelectedTrack(UNMAPPED_TRACK_OPTION);
            const selectedSbId = isSelectedGlobal ? 0 : currentLocation.sbId;
            getRestrictedNames(selectedSbId, resourceType);
            setValidateForm({});
        }
    }, [resourceType, sbLocationId, getRestrictedNames]);
    const collapsedModeOptions = (0, react_1.useMemo)(() => {
        if (hasConflictTerms) {
            return [];
        }
        const selectedSb = successBlocs.find((successBloc) => {
            if (sbId !== undefined) {
                if (sbId === 0) {
                    if (location.key === 0) {
                        return false;
                    }
                }
                return `${successBloc.id}` === `${sbId}`;
            }
            return `${successBloc.id}` === `${currentSbLocationId}`;
        });
        // personal folder
        if ((!selectedSb || location.key === 0) && !hidePersonalFolder) {
            return [
                {
                    icon: 'folder_shared',
                    value: 'My Personal Folder',
                    key: utils_1.PERSONAL_FOLDER_ID,
                },
            ];
        }
        let selectedFolderTree = [];
        // global SB
        if (selectedSb.id === 0) {
            if (location.key !== 1 && location.key !== 'sb') {
                const folders = folderData.filter((data) => data.type === 'folder');
                selectedFolderTree = (0, utils_1.getSelectedFolderTree)(folders, location.key, true, null);
            }
            return [
                {
                    icon: 'build',
                    value: 'Global',
                    key: 1,
                    items: location.key === 1 ? [] : (0, utils_1.buildFolderTree)(selectedFolderTree),
                },
            ];
        }
        const locationKetStr = `${location.key}`;
        if (locationKetStr.includes('folder')) {
            const currentFolderId = locationKetStr.replace('folder_', '');
            selectedFolderTree = (0, utils_1.getSelectedFolderTree)(allFolderData, currentFolderId, false, `sb-${resourceType}s`);
        }
        return [
            {
                key: `sb_${selectedSb.id}`,
                value: selectedSb.display_name,
                iconClass: activityTypes.find((a) => a.activity_type_id === selectedSb.activity_type_id)?.icon_class,
                items: locationKetStr.includes('sb') ? [] : (0, utils_1.buildSbFoldersTree)(selectedFolderTree, utils_1.ROOT_ID),
                sbId: selectedSb.id,
            },
        ];
    }, [
        activityTypes,
        allFolderData,
        currentSbLocationId,
        folderData,
        hasConflictTerms,
        location,
        resourceType,
        sbId,
        successBlocs,
        hidePersonalFolder,
    ]);
    const isPublicDisabled = (location && location.key === utils_1.PERSONAL_FOLDER_ID)
        || (chosenSb && !hasBlockPermissions)
        || (folder && !hasBlockPermissions);
    const privacyOptions = (0, react_1.useMemo)(() => [
        {
            key: 'private',
            value: 'Private',
        },
        {
            key: 'public',
            value: 'Public',
            disabled: isPublicDisabled,
        },
    ], [isPublicDisabled]);
    const [privateOption, publicOption] = privacyOptions;
    const [privacy, setPrivacy] = (0, react_1.useState)(item?.is_shared ? publicOption : privateOption);
    const onPrivacyChange = (0, react_1.useCallback)((e, value) => setPrivacy(value), []);
    const onZoeAvailabilityChange = (0, react_1.useCallback)((e, value) => setAvailableForZoe(value), [setAvailableForZoe]);
    const refreshState = (0, react_1.useCallback)(() => {
        setName(initialName);
        setDescription(item?.description || '');
        setPrivacy(item?.is_shared ? publicOption : privateOption);
        setLocation(initialLocation);
        setValidateForm(false);
        setLocationChanged(false);
    }, [initialLocation, initialName, item, privateOption, publicOption]);
    (0, react_1.useEffect)(() => {
        if (!(0, isEmpty_1.default)(prevItem) && !(0, isEqual_1.default)(prevItem, item)) {
            refreshState();
        }
    }, [item, prevItem, refreshState]);
    (0, react_1.useEffect)(() => {
        setNavList((0, utils_1.getSBFoldersNavList)(sbId, locationChanged, location, getFolderId, selectedFolderId, folderData, allFolderData, successBlocs));
    }, [
        currentFolderLocationId,
        selectedFolderId,
        allFolderData,
        item,
        successBlocs,
        chosenSb.id,
        location,
        locationChanged,
        folderData,
        sbId,
        getFolderId,
    ]);
    (0, react_1.useEffect)(() => {
        if (isPublicDisabled && privacy.key !== privateOption.key) {
            setPrivacy(privateOption);
        }
    }, [isPublicDisabled, privateOption, privacy]);
    const handleSubmitBulkCopy = (0, react_1.useCallback)(async () => {
        const names = (0, utils_1.getCardNamesForBulkCopy)(bulkItems, usedNames);
        const data = bulkItems.map((card) => {
            const itemLabels = labelResources.reduce((acc, labelResource) => {
                if (labelResource.resource_id === card.entity_id) {
                    acc.push(labelResource.label_id);
                }
                return acc;
            }, []);
            return {
                entity_id: card.entity_id,
                entity_type: card.entity_type,
                entity_name: names[card.entity_id],
                sb_id: sbId,
                track_id: selectedTrack.id,
                track_position: newPositionInTrack.key,
                labels: itemLabels,
                folder_id: -1,
            };
        });
        await onBulkSubmitCallback(data);
    }, [bulkItems, labelResources, newPositionInTrack, onBulkSubmitCallback, sbId, selectedTrack, usedNames]);
    const saveChanges = (0, react_1.useCallback)(async () => {
        const validations = !bulkMode ? validateModalForm({ location, hasConflictTerms, sb, name, sbLocationId, privacy }) : {};
        setValidateForm(validations);
        if (!(0, isEmpty_1.default)(validations)) {
            return;
        }
        try {
            setLoading(true);
            if (bulkMode) {
                await handleSubmitBulkCopy();
            }
            else {
                await onSubmitCallback({
                    name,
                    location,
                    hasConflictTerms,
                    sb,
                    sbId,
                    description,
                    labels,
                    selectedFolderId,
                    locationChanged,
                    sbLocationId,
                    privacy,
                    action,
                    selectedTrack,
                    newPositionInTrack,
                    entity: item,
                });
            }
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }, [
        bulkMode,
        validateModalForm,
        location,
        hasConflictTerms,
        sb,
        name,
        sbLocationId,
        handleSubmitBulkCopy,
        onSubmitCallback,
        sbId,
        description,
        labels,
        selectedFolderId,
        locationChanged,
        privacy,
        action,
        selectedTrack,
        newPositionInTrack,
        item,
    ]);
    const onCloseModal = (0, react_1.useCallback)(() => {
        refreshState();
        closeModal();
    }, [closeModal, refreshState]);
    const [foldMode, setFoldMode] = (0, react_1.useState)(!isExpanded);
    (0, react_1.useEffect)(() => {
        setFoldMode(!isExpanded);
    }, [isExpanded]);
    const setCollapseExpandProp = (0, react_1.useCallback)(() => {
        setFoldMode(!foldMode);
    }, [foldMode]);
    const isCollapsed = foldMode && !hasConflictTerms;
    const [isAddingNewOption, setIsAddingNewOption] = (0, react_1.useState)(false);
    const [newFolderName, setNewFolderName] = (0, react_1.useState)('');
    const onClearNewFolderClick = (0, react_1.useCallback)(() => {
        setNewFolderName('');
        setIsAddingNewOption(false);
    }, []);
    (0, react_1.useEffect)(() => {
        onClearNewFolderClick();
    }, [location, onClearNewFolderClick]);
    const [addFolderValidationError, setAddFolderValidationError] = (0, react_1.useState)(null);
    const onAddFolder = (0, react_1.useCallback)(() => {
        setIsAddingNewOption(true);
        setAddFolderValidationError(null);
    }, []);
    const onAddFolderSubmit = (0, react_1.useCallback)(async () => {
        let error = null;
        if (!location || location.key === utils_1.PERSONAL_FOLDER_ID || location.key === 'sb') {
            error = 'Invalid location';
        }
        else if (!newFolderName || newFolderName.trim().length === 0) {
            error = 'Name is required';
        }
        else if (newFolderName && newFolderName.length > utils_1.MAX_NAME_LENGTH) {
            error = `Name is too long and should be less than ${utils_1.MAX_NAME_LENGTH} characters`;
        }
        else if (newFolderName
            && (location?.items ?? []).some((locationItem) => locationItem.value.trim().toLowerCase() === newFolderName.trim().toLowerCase())) {
            error = 'Folder with same name already exists';
        }
        setAddFolderValidationError(error);
        if (error) {
            return;
        }
        let tab;
        // SEGMENT REPORT
        switch (resourceType) {
            case resources_1.SEGMENT: {
                tab = 'sb-segments';
                break;
            }
            case resources_1.REPORT: {
                tab = 'sb-reports';
                break;
            }
            case resources_1.SUCCESS_PLAY: {
                tab = 'sb-successplays';
                break;
            }
            case resources_1.CAMPAIGN: {
                tab = 'sb-campaigns';
                break;
            }
            case resources_1.EXPERIENCE: {
                tab = 'sb-experience';
                break;
            }
            default:
                break;
        }
        const data = {
            name: newFolderName.trim(),
            parent_id: location.key,
        };
        if (location.sbId) {
            data.sb_id = location.sbId;
            data.description = '';
            data.meta_data = '';
            data.tab = tab;
            data.parent_id = null;
            if (location.key.startsWith('folder_')) {
                data.parent_id = parseInt(location.key.replace('folder_', ''), 10);
            }
        }
        const createFolderPromise = location.sbId
            ? createFolders(data)
            : createFolderInGlobal({ folder: JSON.stringify(data) });
        try {
            if (location.sbId) {
                onClearNewFolderClick();
            }
            await createFolderPromise;
            setIsAddingNewOption(true);
            if (!location.sbId) {
                updateFoldersEmber();
            }
            (0, notify_1.renderNotify)({ title: '', text: `Folder ${newFolderName} has been created`, class_name: 'success' });
        }
        catch (err) {
            console.error(`Error while creating new folder: ${err}`, err);
            (0, notify_1.renderNotify)({ title: '', text: 'Error while creating new folder', class_name: 'error' });
        }
        onClearNewFolderClick();
    }, [
        location,
        newFolderName,
        resourceType,
        onClearNewFolderClick,
        createFolders,
        createFolderInGlobal,
        updateFoldersEmber,
    ]);
    const onNewFolderNameChange = (0, react_1.useCallback)((e) => {
        setNewFolderName(e.target.value);
    }, []);
    const onNewFolderNameEnter = (0, react_1.useCallback)((event) => {
        if (event.key === 'Enter') {
            onAddFolderSubmit();
        }
    }, [onAddFolderSubmit]);
    // const isUserAdmin = useIsUserAdmin();
    const isNewFolderDisabled = (0, react_1.useMemo)(() => {
        const isPersonalFolder = location.key === utils_1.PERSONAL_FOLDER_ID;
        const isSuccessBlocRoot = location.key === 'sb';
        const isGlobalReport = !location.sbId && location.key === 1 && resourceType === 'report';
        const selectedSB = location.sbId && successBlocs.find((successBloc) => location.sbId && successBloc.id.toString() === location.sbId.toString());
        const isCollaborator = selectedSB?.collaborators?.indexOf(authUser.username) !== -1;
        const isCreator = selectedSB && selectedSB.creator === authUser.username;
        const selectedTeam = selectedSB && userTeams.find((team) => selectedSB.team_id && selectedSB.team_id === team.id);
        const isAdminInCurrentTeam = selectedTeam?.is_admin;
        const hasPermissions = !location.sbId
            ? hasTools
            : isUserAdmin || isAdminInCurrentTeam || isCollaborator || isCreator;
        return (hasConflictTerms
            || isPersonalFolder
            || isSuccessBlocRoot
            || isGlobalReport
            || !hasPermissions
            || isAddingNewOption);
    }, [
        authUser.username,
        hasConflictTerms,
        hasTools,
        isAddingNewOption,
        isUserAdmin,
        location.key,
        location.sbId,
        resourceType,
        successBlocs,
        userTeams,
    ]);
    const isAddFolderDisabled = (0, react_1.useMemo)(() => isNewFolderDisabled || (shouldDisableFolderButtonForGlobal && location.value === 'Global'), [isNewFolderDisabled, location.value, shouldDisableFolderButtonForGlobal]);
    const showTrackSelection = (0, react_1.useMemo)(() => [resources_1.BULK, resources_1.CAMPAIGN, resources_1.SUCCESS_PLAY, resources_1.EXPERIENCE].includes(resourceType), [resourceType]);
    const disableTrackSelection = (0, react_1.useMemo)(() => Boolean(isLoadingTracks || sbId === 0), [isLoadingTracks, sbId]);
    const trackSelectionTooltip = (0, react_1.useMemo)(() => (sbId === 0 ? 'The Global SuccessBLOC does not contain a Canvas' : ''), [sbId]);
    const submitBtnDisabled = (0, react_1.useMemo)(() => loading || isLoadingUsedNames || !(0, isEmpty_1.default)(validateForm), [isLoadingUsedNames, loading, validateForm]);
    const canSetForZoe = (0, react_1.useMemo)(() => item.entity_type?.toLowerCase() !== 'collection' && privacy.key === 'public'
        && (!item.account_type_group || item.account_type_group?.toLowerCase() !== 'opportunity'), [item, privacy]);
    return (react_1.default.createElement(modal_1.default, { useTransition: true, isOpen: isOpen, closeModal: onCloseModal, onSubmit: saveChanges, submitButtonDisabled: submitBtnDisabled, className: `${action}-${item.id}-modal copy-move-modal`, cancelText: "Cancel", submitText: action, title: title, message: (react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
            !bulkMode && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: (0, classnames_1.default)('error-container', { hide: (0, isEmpty_1.default)(validateForm) }) },
                    react_1.default.createElement("i", { className: "material-icons error-icon" }, "warning"),
                    react_1.default.createElement(typography_1.default, { display: "inline", className: "error-msg" }, validateForm.error)),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(character_count_text_input_1.default, { error: validateForm.name, value: name, onChange: onNameChange, variant: 'outlined', label: `${(0, capitalize_1.default)(resourceType)} Name`, maxLength: maximumNameLength, disabled: !isEditable, fullWidth: true })),
                showDescription && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(input_1.default, { className: "description-text-area", value: description, onChange: onDescChange, variant: "outlined", label: "Description", InputProps: {
                            inputProps: {
                                maxLength: 250,
                            },
                        }, multiline: true, rows: 2, rowsMax: 2, fullWidth: true }))))),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement("div", { className: "text-label location" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", { className: "location-text" }, "Location:"),
                        react_1.default.createElement("span", { className: "location-breadcrumbs" },
                            navList.sb,
                            isEditable
                                && navList.folders.map(({ name: folderName, id }) => (react_1.default.createElement("span", { key: id },
                                    react_1.default.createElement("i", { className: "fa fa-chevron-right" }),
                                    folderName))))),
                    !hasConflictTerms && (react_1.default.createElement(collapse_expand_button_1.default, { foldMode: foldMode, setFoldStateCallback: setCollapseExpandProp }))),
                hasConflictTerms && sb ? (react_1.default.createElement("div", { className: "successbloc-container" },
                    react_1.default.createElement(Icon_1.default, { className: activityType.icon_class }),
                    react_1.default.createElement("span", { className: "successbloc-label" }, sb.display_name))) : (react_1.default.createElement(core_1.Container, { className: (0, classnames_1.default)('tree-container', {
                        'collapsed-tree-container': isCollapsed,
                        'expended-tree-container': !isCollapsed,
                    }) },
                    react_1.default.createElement(tree_view_1.default, { selectedItem: location, options: foldMode && !hasConflictTerms ? collapsedModeOptions : locationOptions, onSelect: setCurrentLocation, autoExpand: !(foldMode && !hasConflictTerms), isAddingNewOption: isAddingNewOption, newFolderName: newFolderName, onNewFolderNameChange: onNewFolderNameChange, onClearNewFolderClick: onClearNewFolderClick, onAddFolderSubmit: onAddFolderSubmit, onNewFolderNameEnter: onNewFolderNameEnter, addFolderValidationError: addFolderValidationError })))),
            hasConflictTerms && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: (0, classnames_1.default)('error-container visible', {
                    'in-segment-error': resourceType === 'segment',
                }) },
                react_1.default.createElement("i", { className: "material-icons error-icon" }, "warning"),
                react_1.default.createElement(typography_1.default, { display: "inline", className: "error-msg" }, `${(0, capitalize_1.default)(resourceType)}s with "in segment/targeted" terms have limited location`))),
            isEditable && !bulkMode && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: "add-folder-container" },
                react_1.default.createElement(add_item_button_1.default, { variant: "body2", onClick: onAddFolder, text: "Add Folder", disabled: isAddFolderDisabled }))),
            resourceType === 'segment' && (react_1.default.createElement(react_1.default.Fragment, null,
                !hidePrivacySwitch
                    ? (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                        react_1.default.createElement("div", { className: "text-label" }, "Privacy"),
                        react_1.default.createElement(switch_group_1.default, { options: privacyOptions, onChange: onPrivacyChange, selected: privacy }))) : null,
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 }, canSetForZoe && (react_1.default.createElement(checkbox_1.default, { checked: availableForZoe, onChange: onZoeAvailabilityChange, color: "primary", label: "Make Segment available for Zoe" }))))),
            isEditable && showTrackSelection && (react_1.default.createElement(StyledTooltip, { title: trackSelectionTooltip, placement: 'top' },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, container: true },
                    react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: "tracks-select" },
                        react_1.default.createElement(advanced_select_1.default, { label: "Track", placeholder: "Select destination track", onChange: handleTrackSelect, options: trackOptions, value: selectedTrack, disabled: disableTrackSelection, fullWidth: true, showOnTop: true })),
                    react_1.default.createElement(Grid_1.default, { item: true, xs: 12, container: true, spacing: 2, alignItems: "center" },
                        react_1.default.createElement(Grid_1.default, { item: true },
                            react_1.default.createElement("span", { className: "text-label" }, "Position")),
                        react_1.default.createElement(Grid_1.default, { item: true },
                            react_1.default.createElement(switch_group_1.default, { disabledGroup: disableTrackSelection, options: newTrackPositionOptions, onChange: onTrackPositionChange, selected: newPositionInTrack, size: "small", className: "new-track-position-selector" })))))))) }));
};
exports.default = CopyMoveResourceModal;
//# sourceMappingURL=copy-move-resource-modal.js.map